import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { Navbar, Header, Footer, MarkdownParser } from "../components";
import { GenericMarkdownLoadingSkeleton } from "../components/LoadingSkeleton";
import ErrorPage from "./ErrorPage";
import customAxios from "../utils/customAxios";

import { styles } from "../styles";

const FasilitasPage = () => {
    const { t, i18n } = useTranslation();
    const currentLanguage = i18n.language;

  const { data, isLoading, isError } = useQuery({
    queryKey: ["facility"],

    queryFn: async () => {
      const response = await customAxios.get("facilities");

      return response?.data?.data || null;
    },
    staleTime: 1000 * 60 * 5,
    refetchOnWindowFocus: false,
  });

  if (isError) {
    return (
      <ErrorPage
        code="500"
        titleKey="error.500_title"
        defaultTitle="Gagal Memuat Data"
        subtitleKey="error.500_subtitle"
        defaultSubtitle="Terjadi masalah saat terhubung ke server kami. Silakan coba lagi nanti atau kembali ke"
      />
    );
  }

  const renderMarkdown = () => {
    if (isLoading) return <GenericMarkdownLoadingSkeleton />;
    if (!data) return null;

    const { content_en, content_id } = data[0];
    return (
      <MarkdownParser
        content={currentLanguage === "en" ? content_en : content_id}
      />
    );
  };

  return (
    <>
      <Navbar />
      <Header title={t("facility.header")} />
      <main
        className={`${styles.paddingX} py-20 flex justify-center gap-10 min-h-[600px]`}
      >
        <section className="max-w-[1152px] w-full flex justify-center space-y-20">
          {renderMarkdown()}
        </section>
      </main>

      <Footer />
    </>
  );
};

export default FasilitasPage;
